import React from "react";
import "./App.css";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import UserLogin from "./userLogin";
import UserRegister from "./userRegister";
import Dashboard from "./dashboard";

// Simple auth selector: replace with real auth check when backend/session is ready
const isAuthenticated = () => {
  // For now, just check a flag in localStorage; this can be wired to real auth later
  return localStorage.getItem("cliperos_auth") === "true";
};

const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/login" element={<UserLogin />} />
        <Route path="/register" element={<UserRegister />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        {/* Default redirect to login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
